<template>
  <div class="lot-side-surface relative z-10 rounded-2xl px-4 pt-5 pb-4">
    <div class="flex items-center gap-3">
      <AlfaInsuranceLogo class="size-10" />
      <div class="flex flex-col">
        <div class="text-sm font-bold text-gray-900">Страховка от повреждений</div>
        <div class="text-sm font-bold text-green-500">35&nbsp;₽/день</div>
      </div>
    </div>

    <ul class="mt-5 space-y-1 text-xs font-semibold text-gray-900 list-disc pl-[18px]">
      <li>Покрывает 85% стоимости ремонта</li>
      <li>Страховая сумма 50 000&nbsp;₽</li>
      <li>Действует на срок аренды</li>
    </ul>


    <button
      class="pl-[18px] text-xs font-medium text-blue-500 underline block mt-1"
      @click="$emit('click-details')"
    >
      Подробнее
    </button>

    <div class="mt-4 text-xs font-medium text-center text-gray-600">
      Совместно с <span class="text-red-alfa-insurance">АльфаСтрахованием</span>
    </div>
  </div>
</template>

<script setup>
import AlfaInsuranceLogo from '~/assets/svg/lot-page/alfa-insurance-logo.svg?component';

defineEmits(['click-details'])
</script>
